var _style, _defs, _defs2, _defs3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeetecicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 214 143.4",
    style: {
      enableBackground: "new 0 0 214 143.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000121271123972768556540000004633084100473020302_);fill:#FFFFFF;}\n\t.st1{clip-path:url(#SVGID_00000084529462674385445390000000269099084566998706_);fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_00000113334122137651933410000001560294124247116194_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "71.7,1 71.7,71.7 142.4,142.4 142.4,71.7  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065056831470266531030000009613716562748465304_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 70.7,
    y: 0,
    style: {
      clipPath: "url(#SVGID_00000065056831470266531030000009613716562748465304_)",
      fill: "#FFFFFF"
    },
    width: 72.7,
    height: 143.4
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000013152206314012349740000007934757531556058777_",
    points: "142.4,1 142.4,71.7 213,142.4 213,71.7  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013152206314012349740000007934757531556058777_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000074423597850261885050000006376925916033171352_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013152206314012349740000007934757531556058777_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 141.4,
    y: 0,
    style: {
      clipPath: "url(#SVGID_00000074423597850261885050000006376925916033171352_)",
      fill: "#FFFFFF"
    },
    width: 72.7,
    height: 143.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000117669821712570141580000012878634169555876497_",
    x: 1,
    y: 71.7,
    width: 70.7,
    height: 70.7
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117669821712570141580000012878634169555876497_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000156580577211155274190000000436157599511580861_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117669821712570141580000012878634169555876497_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    y: 70.7,
    style: {
      clipPath: "url(#SVGID_00000156580577211155274190000000436157599511580861_)",
      fill: "#FFFFFF"
    },
    width: 72.7,
    height: 72.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetecicon);
export default __webpack_public_path__ + "static/media/meetecicon.b0c999d7a69bf7f6a5ff582e6b84ac87.svg";
export { ForwardRef as ReactComponent };